import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Notification.css'; // Ahora es local

export type NotificationType = 'success' | 'error' | 'info';

interface NotificationProps {
  message: string | null;
  type?: NotificationType;
  onClose: () => void;
  duration?: number;
}

/**
 * Componente de notificación reutilizable (Reemplaza al context global)
 */
const Notification: React.FC<NotificationProps> = ({ 
  message, 
  type = 'info', 
  onClose, 
  duration = 5000 
}) => {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [message, duration, onClose]);

  return (
    <AnimatePresence>
      {message && (
        <div className="notification-container">
          <motion.div
            initial={{ opacity: 0, x: 50, scale: 0.8 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.2 } }}
            className={`notification notification-${type}`}
            onClick={onClose}
          >
            <div className="notification-content">
              {message}
            </div>
            <button className="notification-close" onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}>&times;</button>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default Notification;
